<template>
    <div v-if="view === 'day'">
        <day-view :date="date" @set-view="setView" @set-date="rememberDate"></day-view>
    </div>
    <div v-else-if="view === 'week'">
        <week-view :date="date" @set-view="setView" @set-date="rememberDate"></week-view>
    </div>
    <div v-else-if="view === 'month'">
        <month-view :date="date" @set-view="setView" @set-date="rememberDate"></month-view>
    </div>
    <div v-else-if="view === 'year'">
        <year-view :date="date" @set-view="setView" @set-date="setDate"></year-view>
    </div>
</template>
<script setup lang="ts">
import { ref, Ref } from 'vue';
import DayView from '@src/Reservations/Pages/Calendar/DayView.vue';
import WeekView from '@src/Reservations/Pages/Calendar/WeekView.vue';
import MonthView from '@src/Reservations/Pages/Calendar/MonthView.vue';
import YearView from '@src/Reservations/Pages/Calendar/YearView.vue';
import { useCookies } from '@vueuse/integrations/useCookies';

type CalendarDate = {
    day: number | null;
    month: number | null;
    year: number | null;
};

type CalendarView = 'day' | 'week' | 'month' | 'year';

const cookies = useCookies(['calendar.view']);
const view: Ref<CalendarView> = ref(cookies.get('calendar.view') || 'month');

const date: Ref<CalendarDate> = ref({
    day: cookies.get('calendar.day') || null,
    month: cookies.get('calendar.month') || null,
    year: cookies.get('calendar.year') || null,
});

/**
 * Set and remember view
 * @param newView string One of supported calendar views
 */
const setView = (newView: CalendarView) => {
    view.value = newView;
    cookies.set('calendar.view', newView);
};

/**
 * Set given date
 * @param {Object} date Date to set
 */
const setDate = ({ day, month, year }: CalendarDate) => {
    date.value = { day, month, year };
    view.value = 'day';
    rememberDate({ day, month, year });
};

/**
 * Remember date in cookies for calendar view
 * @param {Object} date Date to remember
 */
const rememberDate = ({ day, month, year }: CalendarDate) => {
    cookies.set('calendar.day', day);
    cookies.set('calendar.month', month);
    cookies.set('calendar.year', year);
};
</script>
